import edeColors from 'components/ColorBrowser/ede-colors'

export const isOriginalEdeColor = (color) => {
  if (!color) return false
  const { colorNumber } = color
  return edeColors.has(colorNumber)
}
